<template>
    <div :class="`c-m-message c-m-message--${type}`">
        <icon :icon="`${iconName}`"></icon>
        <slot></slot>
    </div>
</template>
<script>
    import Icon from '../atoms/AtomIcon.vue';
    export default {
        props: {
            type: String,
        },
        components: {
            Icon
        },
        computed: {
            iconName() {
                if (this.type == 'error') {
                    return 'warning';
                } else if (this.type == 'success') {
                    return 'sentiment_very_satisfied';
                }
            }
        },

    }
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeMessage.vue